/* 中文词典：packs 命名空间。见 src/i18n/README.md。 */

import type { TextSpec } from '../text';

const packs = {
  // ---- 牌说明的层面标题（core/lore.ts 的 LORE_SECTIONS）----
  'lore.section.effect': [ '功能' ],
  'lore.section.strategy': [ '策略' ],
  'lore.section.counter': [ '反制' ],
  'lore.section.combo': [ '配合' ],
  'lore.section.hint': [ '操作' ],

  // ---- 牌说明里可复用的术语（core/lore.ts 的 LORE_TERMS）----
  'lore.term.nearDeath': [ '濒死' ],
  'lore.term.lethal': [ '致命' ],
  'lore.term.rescue': [ '救援' ],
  'lore.term.interrupt': [ '打断' ],
  'lore.term.turn': [ '回合' ],
  'lore.term.drawPile': [ '抽牌堆' ],
  'lore.term.discardPile': [ '弃牌堆' ],
  'lore.term.hand': [ '手牌' ],
  'lore.term.combo': [ '连击' ],
  'lore.term.pair': [ '一对' ],
  'lore.term.triple': [ '三条' ],
  'lore.term.fiveDifferent': [ '五张不同名' ],

  // ---- 无效牌额外显示的连击规则（按房间村规逐条决定）----
  'lore.combo.pair.title': [ '功能：一对' ],
  'lore.combo.pair.body': [ '打出任意', { type: 'term', term: 'pair' }, '同名牌，指定一名玩家，从其手中抽走一张牌。' ],
  'lore.combo.triple.title': [ '功能：三条' ],
  'lore.combo.triple.body': [ '打出任意', { type: 'term', term: 'triple' }, '同名牌，指定一名玩家交出一张你指定的牌。\n（若对手没有此牌，则无效果）' ],
  'lore.combo.fiveDifferent.title': [ '功能：五张不同名' ],
  'lore.combo.fiveDifferent.body': [ '打出任意', { type: 'term', term: 'fiveDifferent' }, '牌，可从弃牌堆中任选一张取走。\n此规则同样适用于功能牌：可放弃原有功能，将其用于组合。' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
packs satisfies Record<string, TextSpec>;
export default packs;
